// @flow
import { error } from './common';
import * as types from '../types/parents';
import type {
  PARENT_FETCH_STARTED_TYPE,
  PARENT_FETCH_SUCCEED_TYPE,
  PARENTS_REGISTERED_TYPE,
  PARENT_TYPE,
  UPDATE_PARENT_STARTED_TYPE,
  UPDATE_PARENT_SUCCEED_TYPE,
} from '../types/parents';

export const fetchParentStarted = (id: number): PARENT_FETCH_STARTED_TYPE => ({
  type: types.PARENT_FETCH_STARTED,
  payload: id,
});


export const fetchParentSucceed = (parent: PARENT_TYPE): PARENT_FETCH_SUCCEED_TYPE => ({
  type: types.PARENT_FETCH_SUCCEED,
  payload: parent,
});

export const fetchParentFailed = error(types.PARENT_FETCH_FAILED);

export const registerParents = (entities: {[number]: PARENT_TYPE}): PARENTS_REGISTERED_TYPE => ({
  type: types.PARENTS_REGISTERED,
  payload: {
    entities,
  },
});

export const updateParentStart = (changed_parent: Object): UPDATE_PARENT_STARTED_TYPE => ({
  type: types.UPDATE_PARENT_STARTED,
  payload: changed_parent,
});

export const updateParentSuccess = (parent: PARENT_TYPE): UPDATE_PARENT_SUCCEED_TYPE => ({
  type: types.UPDATE_PARENT_SUCCEED,
  payload: parent,
});

export const updateParentFailed = error(types.UPDATE_PARENT_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/parents.js